<div class="">
    <!-- Header -->
    <div class="row">
        <div class="col-12">
            <h3 class="float-right mr-3">BENEFIT RULES</h3>
        </div>
    </div>

    <!-- Content -->
    <div class="animated fadeIn">
        <!-- Summary Bar -->
        <app-module-summary-bar
            [showPrimary]="true"
            [autoLoadDashboard]="false"
            [items]="summaryItems"
            [primaryLabel]="'Add Rule'"
            [secondaryLabel]="'Export List'"
            (primaryClick)="openCreateRuleModal()"
            (secondaryClick)="exportExcel()"></app-module-summary-bar>

        <!-- Search -->
        <div class="row align-items-center">
            <div class="col-md-6">
                <div style="min-width: 600px; max-width: 100%;">
                    <!-- Tier 5: wj-flex-grid-search (Wijmo-bound) replaced with the
                         standard app-search-input. The wrapper's [quickFilterText]
                         input is wired to apply text-based filtering across the
                         loaded data. -->
                    <app-search-input
                        [placeholder]="'🔍 Search...'"
                        (searchChange)="onSearch($event)">
                    </app-search-input>
                </div>
            </div>
        </div>

        <!-- Loading/Empty State -->
        <div class="row mt-4 animated fadeIn" *ngIf="benefitRules.length === 0">
            <div class="col">
                <div class="alert alert-info text-center" role="alert" *ngIf="loading">
                    <strong>Loading</strong>
                    <br>
                    <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
                    <br>
                    <span class="mt-2">Please wait</span>
                </div>
                <div class="alert alert-warning text-center" role="alert" *ngIf="!loading && noRulesMessage">
                    <strong>{{noRulesMessage}}</strong>
                    <br>
                    <i class="fa fa-warning fa-2x"></i>
                </div>
            </div>
        </div>

        <!-- Rules Grid -->
        <div class="row animated fadeIn mt-1">
            <div class="col-12">
                <div class="card p-0">
                    <div class="card-body bg-white p-0">
                        <div class="row">
                            <div class="col">
                                <div class="grid-panel">
                                    <!-- Tier 5: wj-flex-grid → app-kite-grid. Action
                                         column carries the legacy edit (kept disabled
                                         to preserve the visual layout — the legacy
                                         button had no click handler) + delete
                                         buttons. The wrapper's built-in paginator
                                         replaces the legacy wj-collection-view-navigator. -->
                                    <app-kite-grid
                                        [columnDefs]="columnDefs"
                                        [rowData]="filteredRules()"
                                        [loading]="loading"
                                        [totalRecords]="filteredRules().length"
                                        [pageSize]="filteredRules().length || 1"
                                        (cellClicked)="onCellClicked($event)">
                                    </app-kite-grid>
                                </div>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
